<template>
  <div class="class-charts">
    <!-- 分类得分情况 -->
    <div
      class="canvas-box"
      :style="{ height: height + 'px' }"
      ref="personalBar"
    ></div>
  </div>
</template>
<script>
export default {
  props: ["model"],
  data() {
    return {
      height: 753,
      name: [],

      score: [],
    };
  },
  mounted() {
    if (this.model) {
      this.renderMap();
    }
  },
  watch: {
    model(val) {
      this.renderMap();
    },
  },
  methods: {
    renderMap() {
      let height = 0;
      this.model.map((item) => {
        this.name.push(item.name);
        this.score.push(item.score);
      });
      let personalBar = (window.cc = this.$echarts.init(
        this.$refs["personalBar"],
        null,
        {
          renderer: "svg",
        }
      ));
      height = this.score.length * 104 + 2;
      this.height = height;
      let option = {
        height: height,

        grid: {
          top: "0.5%",
          left: "3%",
          right: "11%",
          bottom: "2.5%",
          containLabel: true,
        },
        yAxis: [
          {
            type: "category",
            data: this.name,
            inverse: true,
            axisTick: { show: false }, // 刻度
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 18,
                color: "black",

                fontWeight: "bold",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#cfe0f4",
                width:2,
              },
            },
          },
        ],
        xAxis: [
          {
            type: "value",
            position: "top",
            max: 10,
            axisLabel: {
              margin: 10,

              interval: 2, //横轴信息全部显示
              textStyle: {
                fontSize: 18,
                color: "#29BDB9",
                fontWeight: "bold",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#cfe0f4",
              },
            },
            splitLine: {
              lineStyle: {
                width:2,
                color: ["#cfe0f4", "#E6EEF9", "#E6EEF9", "#E6EEF9", "#E6EEF9"],
              },
            },
          },
        ],
        series: [
          {
            type: "bar",
            barWidth: 36,
            data: this.score,

            label: {
              normal: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                color: "#29BDB9",
                // new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                //     offset: 0,
                //     color: '#CFFAF9' // 0% 处的颜色
                // }, {
                //     offset: 1,
                //     color: '#29BDB9' // 100% 处的颜色
                // }], false),
              },
            },
          },
        ],
      };

      personalBar.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.class-charts {
  position: relative;
  .canvas-box {
    width: 420px;
    overflow: hidden;
    // height: 760px;
    // margin: -113px 0 0 37px;
    margin: -35px auto 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dataView/echarts/all/personalBar.vue